import { Component, OnInit } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ProductFamily } from './menu.interfaces';
import { MenuConfigService } from './services/menu-config/menu-config.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    standalone: false
})
export class MenuComponent implements OnInit {

  public productFamilies$: Observable<ProductFamily[]> = new Observable();

  public productFamilies: ProductFamily[] = [];

  public selectedFamily?: ProductFamily = undefined;

  constructor(
    private menuConfigService: MenuConfigService,
    public translateService: TranslateService) {
      this.fetchProducts();
  }

  ngOnInit(): void { }

  selectCategory(categoryName: string) {
      if(categoryName === this.selectedFamily?.id) {
        this.selectedFamily = undefined;
        return
      }

      this.selectedFamily = this.productFamilies.find( ( category ) => category.id === categoryName);
      this.scrollElementIntoView('menu-elements')
  }

  trackById(_index: number, item: ProductFamily) {
    return item.id;
  }

  private fetchProducts() {
    this.productFamilies$ = this.menuConfigService.getProducts().pipe(
      tap( (products: ProductFamily[]) => this.productFamilies = products )
    )
  }

  private scrollElementIntoView(label: string) {
    // Should wait for Change Detection, and conditional element (*ngIf) to render
    // setTimeout does the trick.
    setTimeout( () => {
      const element = document.getElementById(label);
      element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 0);
  }
}
